/** OUK home screen logo served from public/. */
export const APP_LOGO = '/OUK_Home_Screen_Logo_150x150.png';
